"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const common_1 = require("../../../../../common");
const validation_1 = require("./validation");
const AmountDialog = (props) => {
    const { initialValues, message, testId = "AmountDialogForm", ...rest } = props;
    const { balance } = initialValues;
    const { token: { template: { contract: { decimals, symbol } = common_1.emptyContract } = common_1.emptyTemplate } = common_1.emptyToken } = balance;
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { initialValues: initialValues, validationSchema: validation_1.validationSchema, message: message, testId: testId, ...rest, children: (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.EthInput, { name: "amount", units: decimals, symbol: `${symbol} ` }) }));
};
exports.AmountDialog = AmountDialog;
//# sourceMappingURL=index.js.map